import { useState, useEffect } from "react";

/**
 * Hook personnalisé pour gérer l'authentification
 * Synchronise automatiquement l'état d'authentification dans toute l'application
 */
export const useAuth = () => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Fonction pour charger l'authentification depuis localStorage
  const loadAuth = () => {
    try {
      const storedToken = localStorage.getItem("token");
      const storedUser = localStorage.getItem("user");

      if (storedToken && storedUser) {
        const parsedUser = JSON.parse(storedUser);
        setUser(parsedUser);
        setToken(storedToken);
        console.log("✅ useAuth - Authentification chargée:", parsedUser);
      } else {
        setUser(null);
        setToken(null);
        console.log("❌ useAuth - Pas d'authentification");
      }
    } catch (error) {
      console.error("❌ useAuth - Erreur lors du chargement:", error);
      setUser(null);
      setToken(null);
      // Nettoyer les données corrompues
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    } finally {
      setIsLoading(false);
    }
  };

  // Fonction pour mettre à jour l'authentification
  const updateAuth = (userData, userToken) => {
    if (userData && userToken) {
      setUser(userData);
      setToken(userToken);
      localStorage.setItem("token", userToken);
      localStorage.setItem("user", JSON.stringify(userData));
      console.log("✅ useAuth - Authentification mise à jour:", userData);
    } else {
      setUser(null);
      setToken(null);
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      console.log("✅ useAuth - Authentification supprimée");
    }
  };

  // Fonction pour se déconnecter
  const logout = () => {
    updateAuth(null, null);
  };

  // Charger l'authentification au montage du composant
  useEffect(() => {
    loadAuth();
  }, []);

  // Écouter les changements d'authentification
  useEffect(() => {
    const handleAuthChange = (event) => {
      console.log(
        "🔄 useAuth - Événement authStateChanged reçu:",
        event.detail
      );
      if (event.detail) {
        updateAuth(event.detail.user, event.detail.token);
      }
    };

    const handleStorageChange = (event) => {
      if (event.key === "token" || event.key === "user") {
        console.log("🔄 useAuth - Changement localStorage détecté");
        loadAuth();
      }
    };

    // Écouter les événements personnalisés
    window.addEventListener("authStateChanged", handleAuthChange);
    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("authStateChanged", handleAuthChange);
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  return {
    user,
    token,
    isLoading,
    isAuthenticated: !!user && !!token,
    updateAuth,
    logout,
    loadAuth,
  };
};
